import React from 'react';

import {
  StockFilterMultiSelectPartsOptionType,
  StockFilterMultiSelectPartsSelectedOptionType,
} from '@/components/StockFilterMultiSelectParts/types';
import StockFilterMultiSelectParts from '@/components/StockFilterMultiSelectParts';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  deleteCarComplectations,
  getSelectedCars,
  getStockBrandsAndModels,
  setCarComplectation,
  setCarComplectationsAll,
  setPage,
} from '@/store/reducers/cars-stock';
import { getComplectationOptionsBySelectedModels } from '@/modules/CarsStock/components/common.helpers';

function ComplectationFilter() {
  const dispatch = useTypedDispatch();
  const selectedComplectations =
    useTypedSelector(getSelectedCars).selectedComplectations;
  const selectedModels = useTypedSelector(getSelectedCars).selectedModels;
  const stockBrandsAndModels = useTypedSelector(getStockBrandsAndModels);

  const complectationOptions = getComplectationOptionsBySelectedModels(
    stockBrandsAndModels,
    selectedModels
  );
  const isDisabledComplectation = selectedModels && selectedModels.length === 0;

  const handleChangeComplectation = (
    complectation: StockFilterMultiSelectPartsSelectedOptionType
  ) => {
    dispatch(setCarComplectation(complectation));
    dispatch(setPage(1));
  };

  const handleChangeComplectationsAll = (
    complectations: StockFilterMultiSelectPartsOptionType
  ) => {
    dispatch(setCarComplectationsAll(complectations));
    dispatch(setPage(1));
  };

  const handleClearComplectation = () => {
    dispatch(deleteCarComplectations());
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelectParts
      label="Комплектация"
      options={complectationOptions}
      selectedOptions={selectedComplectations}
      onChange={handleChangeComplectation}
      onChangeAll={handleChangeComplectationsAll}
      onClear={handleClearComplectation}
      disabled={isDisabledComplectation}
      disabledHint="Сначала выберите модель авто"
    />
  );
}

export default ComplectationFilter;
